import React from 'react'
import ReactSVG from 'react-svg'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import shareIcon from '../../../../images/my-rentals.svg'
import styles from './navigation-account-side.css'

const MyRentalsIcon = ({ isKid }) => {
  return (
    <div
      className={classNames(styles.myRentalsIcon, {
        [styles.isKid]: isKid
      })}
    >
      <ReactSVG
        src={shareIcon}
        className={classNames({
          [styles.svgWrapper]: isKid
        })}
      />
    </div>
  )
}

MyRentalsIcon.propTypes = {
  isKid: PropTypes.bool
}

MyRentalsIcon.defaultProps = {
  isKid: false
}

export default MyRentalsIcon
